import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter as Router } from "react-router-dom";
import RouterComponent from './routes/RouterComponent';
import { getSessionStorageValue } from './effects/utils/session-storage';
import { useAuthStateValue } from './providers/AuthStateProvider';
import { Action } from './reducers/reducer.action';
import UserInfoModel from './models/UserInfoModel';
import 'font-awesome/css/font-awesome.min.css';

function App() {
  //@ts-ignore
  const [{ }, dispatch] = useAuthStateValue()

  useEffect(() => {
    const userString = getSessionStorageValue('user');

    if (userString) {

      dispatch({
        type: Action.SET_USER,
        payload: JSON.parse(userString)
      })
    }
  }, [])


  return (
    <div className="App">
   
      {/* Overlay added when login screen is opened */}
      <div id="overlay">&nbsp;</div>

      <Router>
        
        <RouterComponent />
        
      </Router>

    </div>
  );
}

export default App;
